/**
 * SSR-safe localStorage wrapper.
 *
 * All reads/writes go through these helpers so we never reference
 * `window` directly and SSR (Node) environments get safe no-ops.
 */

const isClient =
  typeof globalThis !== 'undefined' && 'localStorage' in globalThis;

export const storage = {
  get(key: string): string | null {
    if (!isClient) {
      return null;
    }
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },

  set(key: string, value: string): void {
    if (!isClient) {
      return;
    }
    try {
      localStorage.setItem(key, value);
    } catch {
      // quota exceeded or blocked
    }
  },

  remove(key: string): void {
    if (!isClient) {
      return;
    }
    try {
      localStorage.removeItem(key);
    } catch {
      // blocked
    }
  },

  getJSON<T>(key: string): T | null {
    const raw = storage.get(key);
    if (raw === null) {
      return null;
    }
    try {
      return JSON.parse(raw) as T;
    } catch {
      return null;
    }
  },

  setJSON(key: string, value: unknown): void {
    storage.set(key, JSON.stringify(value));
  },
};
